import { colors as colors$1 } from '@ui/kit/design-tokens';
import { combineTokens } from '@utils/css';

const colors = combineTokens("--text--heading-color", {
  h1: colors$1.text.primary,
  h2: colors$1.text.primary,
  h3: colors$1.text.primary,
  h4: colors$1.text.primary,
  h5: colors$1.text.primary,
  h6: colors$1.text.primary,
  meta: colors$1.gray.sim65
});

export { colors };
//# sourceMappingURL=headings.js.map
